import { render, staticRenderFns } from "./InternalResetPassword.vue?vue&type=template&id=bcbec538&scoped=true"
import script from "./InternalResetPassword.vue?vue&type=script&lang=js"
export * from "./InternalResetPassword.vue?vue&type=script&lang=js"
import style0 from "./InternalResetPassword.vue?vue&type=style&index=0&id=bcbec538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbec538",
  null
  
)

export default component.exports